/* eslint-disable react/require-default-props */
import React from 'react';
import { Spin } from 'antd';
import { Avatar, Container } from './styles';

interface AvatarProps {
    file: string;
    loading: boolean;
    roundShape?: boolean;
}
const AvatarComponent: React.FC<AvatarProps> = ({
    file,
    loading,
    roundShape,
}) => {
    return (
        <Container>
            {loading ? (
                <Spin size="large" />
            ) : (
                <Avatar src={file} roundShape={roundShape} />
            )}
        </Container>
    );
};

export default AvatarComponent;
